const candidateAuthUrls = {
    login: {
        url: '/auth-candidate/login'
    },
    logout: {
        url: '/auth-candidate/logout'
    },
    identification: {
        url: '/auth-candidate/identification'
    },
    candidateInfo: {
        url: '/auth-candidate/candidateInfo'
    }
};
export default candidateAuthUrls;
